var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmazonLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79945 5.9375H9.39148V4.67188C9.39148 3.19883 8.23218 2 6.80769 2C5.38321 2 4.2239 3.19883 4.2239 4.67188V5.9375H3.81593C3.36547 5.9375 3 6.31543 3 6.78125V10.1562C3 10.6221 3.36547 11 3.81593 11H9.79945C10.2499 11 10.6154 10.6221 10.6154 10.1562V6.78125C10.6154 6.31543 10.2499 5.9375 9.79945 5.9375ZM8.0316 5.9375H5.58379V4.67188C5.58379 3.97403 6.13284 3.40625 6.80769 3.40625C7.48254 3.40625 8.0316 3.97403 8.0316 4.67188V5.9375Z",
    fill: "#B12704"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmazonLock);
export default __webpack_public_path__ + "static/media/AmazonLock.e69bcbebfee9c30d67cb47290214f500.svg";
export { ForwardRef as ReactComponent };